import * as types from '../actionType'

const initialState = []

const sellerOrderStat = (state = initialState, action) => {
    switch (action.type) {
        case types.SELLER_GET_ORDERS_STAT:
            return action.payload
        default:
            return state
    }
}


export { sellerOrderStat }